/*
 * Copyright (c) 2023-2024. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import ConsumeType from '@/model/dataLayer/api/buffet/ConsumeType'
import Payment from '@/model/dataLayer/api/common/Payment'
import Servant from '@/model/dataLayer/api/tableAndPerson/Servant'
import PaymentColors from '@/model/dataLayer/api/common/PaymentColors'
import i18n from '@/i18n'
import { forceGetSystemSetting } from '@/model/dataLayer/api/NewSettings'
import { getNiceRestaurantInfo } from '@/model/dataLayer/service/otherService'

const entity = {
  paymentArr: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => await Payment.getList(true),
        multiple: true,
        color: PaymentColors.getList(),
        itemText: '_langsname'
      }
    },
    tableConfig: {
      width: '220px'
    },
    displayName: 'PaymentType'
  },
  orderId: {
    type: IKDataEntity.Types.Integer,
    displayName: 'orderNumber', // 订单编号
    tableConfig: {
      align: 'start'
    },
    formConfig: {
      disableNew: true,
      disableEdit: true,
      requiredNew: false
    }
  },
  tableName: {
    displayName: 'tableNumber',
    tableConfig: {
      sortable: true,
      overwrite: true
    }
  },
  servantName: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => await Servant.getList(true),
        itemText: 'name',
        itemValue: 'name'
      }
    },
    displayName: i18n.t('staff'),
    header: false
  },
  consumeTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: ConsumeType.getList,
        itemText: 'localName'
      }
    }
  },
  updateTimestamp: {
    displayName: 'TimeStamp', // 结账时间
    type: IKDataEntity.Types.Date
  },
  totalPrice: {
    displayName: 'cash_amount',
    tableConfig: {
      sortable: true,
      overwrite: true
    }
  },
  printFrenchBill: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    },
    header: async () => {
      const res = await forceGetSystemSetting({
        section: 'aadenAdmin',
        sKey: 'useFrenchBill',
        sValue: '0',
        defaultValue: '0',
        sType: 'boolean',
        minimumVersion: '1.7.784',
        sOptions: '',
        tagList: 'basic'
      })
      return res !== '0'
    }
  },
  printItalyBill: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    },
    header: async () => {
      const res = await forceGetSystemSetting({
        section: 'aadenAdmin',
        sKey: 'useItalyBill',
        sValue: '0',
        defaultValue: '0',
        sType: 'boolean',
        minimumVersion: '1.7.784',
        sOptions: '',
        tagList: 'basic'
      })
      return res !== '0'
    }
  }

}

const config = {
  load: async function (filter) {
    const useDailySerial = (await getNiceRestaurantInfo()).useDailySerialAsQueueNumber
    const timespan = filter[0].dateFilter.join(' - ')
    const list = (await hillo.get('Orders.php', {
      op: 'withSortAndFilter',
      lang: GlobalSettings.getLang(),
      timespan
    }, { timeout: 5 * 60 * 1000 })).content

    list.map(function (item) {
      if (item.payLogs) {
        item.paymentArr = item.payLogs.map(n => parseInt(n.paymentMethodId)).join(',')
      } else {
        item.paymentArr = '0'
      }
      if (useDailySerial === '1' && (item.tableName.startsWith('W') || item.tableName.startsWith('w'))) {
        item.tableName = item.dailySerial ? 'W' + item.dailySerial : item.tableName
      }
      if (item.rawAddressInfo) {
        try {
          const decode = JSON.parse(item.rawAddressInfo)
          item.isTakeaway = decode?.metaData?.takeawayWebVersion === 'new'
        } catch (e) {

        }
      } else {
        item.isTakeaway = false
      }
      item.id = item.orderId
      return item
    })
    const cashbookId = (await ConsumeType.getList(true)).find(it => it.name === 'BBH').id
    return list.filter(it => it.consumeTypeId.toString() !== cashbookId.toString())
  }
}
export default IKDataEntity.ModelFactory(entity, config)

export async function printFrenchBillController (item) {
  return await hillo.post('FrenchBillController.php?op=addAndPrint', {
    ...item
  })
}
